import { AppConfigModel } from "../abstract/app-config.model";

export class EcoTaxSector extends AppConfigModel {

    static override CLASS_NAME: string = 'EcoTaxSector';
}
